module.exports = __webpack_public_path__ + "static/media/park.eafc741d.svg";